import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VRow,
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.existeBusqueda,
              expression: "!existeBusqueda",
            },
          ],
        },
        [
          _c(VCol, { attrs: { sm: "12" } }, [
            _c("p", { staticStyle: { "margin-bottom": "0" } }, [
              _vm._v(_vm._s(_vm.$t("search.no_results"))),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.existeBusqueda,
              expression: "existeBusqueda",
            },
          ],
          staticClass: "display-1",
        },
        [_vm._v(_vm._s(_vm.$t("search.all_results")))]
      ),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.existeBusqueda,
                      expression: "existeBusqueda",
                    },
                  ],
                },
                [
                  _vm._v(
                    '"' +
                      _vm._s(_vm.encontrado.q) +
                      '" ' +
                      _vm._s(_vm.$t("search.coincidences")) +
                      " "
                  ),
                  _c(
                    VBtn,
                    { attrs: { "x-small": "", color: "secondary", light: "" } },
                    [_vm._v(_vm._s(_vm.encontrado.found))]
                  ),
                  _vm._v(
                    " (" +
                      _vm._s(_vm.encontrado.search_time_ms / 1000) +
                      " " +
                      _vm._s(_vm.$t("search.seconds")) +
                      ") "
                  ),
                ],
                1
              ),
              _c(
                VBreadcrumbs,
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.existeBusqueda,
                      expression: "existeBusqueda",
                    },
                  ],
                  staticClass: "pa-0 py-2",
                },
                [_vm._v(_vm._s(_vm.$t("search.continue_filtering")))]
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter"),
                      ])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(_vm.$t("btns.filter")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VRow,
        [
          _vm.filter_enabled
            ? _c(
                VCol,
                { staticClass: "col-md-3 d-block d-md-none mb-2" },
                [
                  _c(
                    VCard,
                    { staticClass: "d-block  pb-2" },
                    [
                      _c(VCardTitle, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("search.search_filters")) + " "
                        ),
                      ]),
                      _c(
                        VCol,
                        {
                          staticClass: "pb-0 d-flex align-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "caption",
                              class: !_vm.semanticSearch
                                ? "primary--text font-weight-bold"
                                : "grey--text",
                            },
                            [_vm._v("Clásica")]
                          ),
                          _c(VSwitch, {
                            staticClass: "mx-2 mt-0",
                            attrs: { "hide-details": "", dense: "" },
                            model: {
                              value: _vm.semanticSearch,
                              callback: function ($$v) {
                                _vm.semanticSearch = $$v
                              },
                              expression: "semanticSearch",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "caption",
                              class: _vm.semanticSearch
                                ? "primary--text font-weight-bold"
                                : "grey--text",
                            },
                            [_vm._v("Semántica")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "d-flex", attrs: { cols: "12" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$t("search.search"),
                              placeholder: "Buscar...",
                              type: "text",
                              outlined: "",
                              dense: "",
                              "append-icon": "mdi-magnify",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.buscar(true)
                              },
                              "click:append": function ($event) {
                                return _vm.buscar(true)
                              },
                            },
                            model: {
                              value: _vm.filtro.q,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "q", $$v)
                              },
                              expression: "filtro.q",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "d-flex", attrs: { cols: "12" } },
                        [
                          _c("organizacion-component", {
                            model: {
                              value: _vm.filtro.domain,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "domain", $$v)
                              },
                              expression: "filtro.domain",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VCombobox, {
                            attrs: {
                              label: _vm.$t("menu.object_type"),
                              multiple: "",
                              chips: "",
                              outlined: "",
                              dense: "",
                              items: _vm.object_types,
                              attach: true,
                            },
                            model: {
                              value: _vm.filtro.object,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "object", $$v)
                              },
                              expression: "filtro.object",
                            },
                          }),
                          _c(VCombobox, {
                            attrs: {
                              label: _vm.$t("menu.query_by_search"),
                              multiple: "",
                              chips: "",
                              outlined: "",
                              dense: "",
                              items: _vm.query_by_types,
                              attach: true,
                            },
                            model: {
                              value: _vm.filtro.query_by,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "query_by", $$v)
                              },
                              expression: "filtro.query_by",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.showFinalTable
                        ? _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  label: _vm.$t("menu.final_table"),
                                  outlined: "",
                                  dense: "",
                                  items: _vm.final_table_options,
                                },
                                model: {
                                  value: _vm.filtro.final_table,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filtro, "final_table", $$v)
                                  },
                                  expression: "filtro.final_table",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: "Zona",
                              placeholder: "Zona",
                              type: "text",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.filtro.zone,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "zone", $$v)
                              },
                              expression: "filtro.zone",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "text-right", attrs: { cols: "12" } },
                        [
                          _c(
                            VBtn,
                            {
                              staticClass: "default mr-1",
                              attrs: { outlined: "" },
                            },
                            [_vm._v(" Limpiar ")]
                          ),
                          _c(
                            VBtn,
                            {
                              staticClass: "primary",
                              on: { click: _vm.buscar },
                            },
                            [_vm._v(" Buscar ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            "div",
            { class: _vm.getClassTable },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.existeBusqueda,
                      expression: "existeBusqueda",
                    },
                  ],
                  staticClass: "d-flex align-center mb-2",
                },
                [
                  _c(VSelect, {
                    staticStyle: { "max-width": "280px" },
                    attrs: {
                      items: _vm.sortOptions,
                      label: "Ordenar por",
                      "prepend-inner-icon": "mdi-sort",
                      dense: "",
                      outlined: "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.sortOption,
                      callback: function ($$v) {
                        _vm.sortOption = $$v
                      },
                      expression: "sortOption",
                    },
                  }),
                  _vm.sortOption !== "relevance"
                    ? _c(
                        VBtn,
                        {
                          staticClass: "ml-1",
                          attrs: {
                            icon: "",
                            title: _vm.sortDesc ? "Descendente" : "Ascendente",
                          },
                          on: {
                            click: function ($event) {
                              _vm.sortDesc = !_vm.sortDesc
                            },
                          },
                        },
                        [
                          _c(VIcon, [
                            _vm._v(
                              _vm._s(
                                _vm.sortDesc
                                  ? "mdi-sort-descending"
                                  : "mdi-sort-ascending"
                              )
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                VCard,
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.existeBusqueda,
                      expression: "existeBusqueda",
                    },
                  ],
                  staticClass: "pb-3",
                },
                _vm._l(_vm.sortedResults, function (item, index) {
                  return _c(
                    "div",
                    {
                      key:
                        "item_" +
                        item.id +
                        "_" +
                        item.titulo +
                        "_" +
                        _vm.getRamdonKey(),
                      staticClass: "item-busqueda",
                    },
                    [
                      item.tipo_objeto == _vm.TYPSE_SENSE_TYPE_OBJECTS.TABLE ||
                      item.tipo_objeto == _vm.TYPSE_SENSE_TYPE_OBJECTS.VIEW
                        ? _c("item-table-view-component", {
                            attrs: { item: item },
                            on: {
                              onChangeObjeto: _vm.onChangeObjeto,
                              onVerObjeto: _vm.onVerObjeto,
                              onRequestObjeto: _vm.onRequestObjeto,
                            },
                          })
                        : _vm._e(),
                      item.tipo_objeto == _vm.TYPSE_SENSE_TYPE_OBJECTS.TERM
                        ? _c("item-term-component", {
                            attrs: { item: item },
                            on: { onVerObjeto: _vm.onVerObjeto },
                          })
                        : _vm._e(),
                      item.tipo_objeto ==
                      _vm.TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE
                        ? _c("item-tbl-dashboard-component", {
                            attrs: { item: item },
                            on: {
                              onChangeObjeto: _vm.onChangeObjeto,
                              onVerObjeto: _vm.onVerObjeto,
                              onRequestObjeto: _vm.onRequestObjeto,
                            },
                          })
                        : _vm._e(),
                      item.tipo_objeto ==
                      _vm.TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD
                        ? _c("item-tbl-dashboard-component", {
                            attrs: { item: item },
                            on: {
                              onChangeObjeto: _vm.onChangeObjeto,
                              onVerObjeto: _vm.onVerObjeto,
                              onRequestObjeto: _vm.onRequestObjeto,
                            },
                          })
                        : _vm._e(),
                      item.tipo_objeto ==
                      _vm.TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET
                        ? _c("item-tbl-dashboard-component", {
                            attrs: { item: item },
                            on: {
                              onChangeObjeto: _vm.onChangeObjeto,
                              onVerObjeto: _vm.onVerObjeto,
                              onRequestObjeto: _vm.onRequestObjeto,
                            },
                          })
                        : _vm._e(),
                      item.tipo_objeto ==
                      _vm.TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT
                        ? _c("item-tbl-dashboard-component", {
                            attrs: { item: item },
                            on: {
                              onChangeObjeto: _vm.onChangeObjeto,
                              onVerObjeto: _vm.onVerObjeto,
                              onRequestObjeto: _vm.onRequestObjeto,
                            },
                          })
                        : _vm._e(),
                      item.tipo_objeto ==
                      _vm.TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT
                        ? _c("item-tbl-datasource-component", {
                            attrs: { item: item },
                            on: {
                              onChangeObjeto: _vm.onChangeObjeto,
                              onVerObjeto: _vm.onVerObjeto,
                              onRequestObjeto: _vm.onRequestObjeto,
                            },
                          })
                        : _vm._e(),
                      item.tipo_objeto ==
                      _vm.TYPSE_SENSE_TYPE_OBJECTS.GDS_DATASOURCE
                        ? _c("item-tbl-datasource-component", {
                            attrs: { item: item },
                            on: {
                              onChangeObjeto: _vm.onChangeObjeto,
                              onVerObjeto: _vm.onVerObjeto,
                              onRequestObjeto: _vm.onRequestObjeto,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
              [
                _c(
                  "div",
                  { staticClass: "text-left mt-3" },
                  [
                    _c(VPagination, {
                      attrs: {
                        length:
                          _vm.encontrado.found && _vm.encontrado.per_page
                            ? Math.ceil(
                                _vm.encontrado.found / _vm.encontrado.per_page
                              )
                            : 0,
                        "total-visible": 7,
                        circle: "",
                      },
                      on: { input: _vm.next },
                      model: {
                        value: _vm.encontrado.page,
                        callback: function ($$v) {
                          _vm.$set(_vm.encontrado, "page", $$v)
                        },
                        expression: "encontrado.page",
                      },
                    }),
                  ],
                  1
                ),
              ],
            ],
            2
          ),
          _vm.filter_enabled
            ? _c(
                VCol,
                { staticClass: "col-md-3 pl-0 d-none d-md-block" },
                [
                  _c(
                    VCard,
                    { staticClass: "d-block  pb-2" },
                    [
                      _c(VCardTitle, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("search.search_filters")) + " "
                        ),
                      ]),
                      _c(
                        VCol,
                        {
                          staticClass: "pb-0 d-flex align-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "caption",
                              class: !_vm.semanticSearch
                                ? "primary--text font-weight-bold"
                                : "grey--text",
                            },
                            [_vm._v("Clásica")]
                          ),
                          _c(VSwitch, {
                            staticClass: "mx-2 mt-0",
                            attrs: { "hide-details": "", dense: "" },
                            model: {
                              value: _vm.semanticSearch,
                              callback: function ($$v) {
                                _vm.semanticSearch = $$v
                              },
                              expression: "semanticSearch",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "caption",
                              class: _vm.semanticSearch
                                ? "primary--text font-weight-bold"
                                : "grey--text",
                            },
                            [_vm._v("Semántica")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "d-flex", attrs: { cols: "12" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$t("search.search"),
                              placeholder: "Buscar...",
                              type: "text",
                              outlined: "",
                              dense: "",
                              "append-icon": "mdi-magnify",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.buscar(true)
                              },
                              "click:append": function ($event) {
                                return _vm.buscar(true)
                              },
                            },
                            model: {
                              value: _vm.filtro.q,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "q", $$v)
                              },
                              expression: "filtro.q",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "d-flex", attrs: { cols: "12" } },
                        [
                          _c("organizacion-component", {
                            model: {
                              value: _vm.filtro.domain,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "domain", $$v)
                              },
                              expression: "filtro.domain",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VCombobox, {
                            attrs: {
                              label: _vm.$t("menu.object_type"),
                              multiple: "",
                              chips: "",
                              outlined: "",
                              dense: "",
                              items: _vm.object_types,
                              attach: true,
                            },
                            model: {
                              value: _vm.filtro.object,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "object", $$v)
                              },
                              expression: "filtro.object",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VCombobox, {
                            attrs: {
                              label: _vm.$t("menu.query_by_search"),
                              multiple: "",
                              chips: "",
                              outlined: "",
                              dense: "",
                              items: _vm.query_by_types,
                              attach: true,
                            },
                            model: {
                              value: _vm.filtro.query_by,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "query_by", $$v)
                              },
                              expression: "filtro.query_by",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.showFinalTable
                        ? _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  label: _vm.$t("menu.final_table"),
                                  outlined: "",
                                  dense: "",
                                  items: _vm.final_table_options,
                                },
                                model: {
                                  value: _vm.filtro.final_table,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filtro, "final_table", $$v)
                                  },
                                  expression: "filtro.final_table",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: "Zona",
                              placeholder: "Zona",
                              type: "text",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.filtro.zone,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtro, "zone", $$v)
                              },
                              expression: "filtro.zone",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "text-right", attrs: { cols: "12" } },
                        [
                          _c(
                            VBtn,
                            {
                              staticClass: "default mr-1",
                              attrs: { outlined: "" },
                              on: { click: _vm.onLimpiar },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("search.clean")) + " ")]
                          ),
                          _c(
                            VBtn,
                            {
                              staticClass: "primary",
                              on: {
                                click: function ($event) {
                                  return _vm.buscar(true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("search.search")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME,
          attrs: { title: "Request Access", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-table-component", {
                key: _vm.key_request,
                ref: _vm.MODAL_NAME + "_body",
                attrs: { "tpl-to-work": _vm.objToRequest },
                on: {
                  submit: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME + "_body"].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_METADATA,
          attrs: { title: "Request Change Metadata", width: 1800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                key: _vm.key_meta,
                ref: _vm.MODAL_NAME_METADATA + "_body",
                attrs: {
                  "tpl-to-work": _vm.objToRequest,
                  "is-change-request": _vm.TYPE_CHANGE_METADA.CHANGE_REQUEST,
                  "hide-env": true,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME_METADATA + "_body"].validateForm(
                        "ok",
                        $event
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_METADATA_VIEW,
          attrs: { title: "Metadata Table Detail", width: 1800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                key: _vm.key_view,
                ref: "viewmetadataTableRef",
                attrs: {
                  "tpl-to-work": _vm.objToRequest,
                  "is-change-request": _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                  "lazy-load-params": _vm.lazyLoadParamsForViewer,
                  "hide-env": true,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA_VIEW].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsLeft" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "secondary", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.viewmetadataTableRef.clickDownloadCSV()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("botones.boton_download_metadata")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASOURCE_METADATA_VIEW,
          attrs: {
            title:
              (_vm.isReadonly ? "VIEW" : "CHANGE") + " METADATA DATASOURCE",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-datasource", {
                ref: _vm.MODAL_DATASOURCE_METADATA_VIEW + "_body",
                attrs: {
                  item: _vm.objDatasource,
                  "show-buttons": !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  "is-change-request": _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_DATASOURCE_METADATA_VIEW
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_DATASOURCE_METADATA_VIEW + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_SELECT_USER_TABLEAU,
          attrs: {
            title:
              _vm.tableauType == "datasource"
                ? _vm.objDatasource.path_name +
                  "/" +
                  _vm.objDatasource.object_name
                : _vm.objDashboard.path_name +
                  "/" +
                  _vm.objDashboard.object_name,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-select-tableau-user", {
                ref: _vm.MODAL_SELECT_USER_TABLEAU + "_body",
                attrs: {
                  "user-tableau-options": _vm.userTableauOptions,
                  item:
                    _vm.tableauType == "datasource"
                      ? _vm.objDatasource
                      : _vm.objDashboard,
                  "tableau-type": _vm.tableauType,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_SELECT_USER_TABLEAU].onClose()
                  },
                  openMetaDataTableau: _vm.openMetadataTableau,
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_SELECT_USER_TABLEAU + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, [_vm._v("icon-check")]),
                  _vm._v(" " + _vm._s(_vm.$t("botones.boton_aceptar")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASOURCE_METADATA_ACCESS,
          attrs: { title: "DATASOURCE ACCESS REQUEST", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-datasource", {
                ref: _vm.MODAL_DATASOURCE_METADATA_ACCESS + "_body",
                attrs: {
                  item: _vm.objDatasource,
                  "user-tableau": _vm.userTableau,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_DATASOURCE_METADATA_ACCESS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_DATASOURCE_METADATA_ACCESS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_WORKBOOK_METADATA_VIEW,
          attrs: {
            title: (_vm.isReadonly ? "View" : "Change") + " Metadata workbook",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-dashboard", {
                ref: _vm.MODAL_WORKBOOK_METADATA_VIEW + "_body",
                attrs: {
                  item: _vm.objDashboard,
                  "show-buttons": !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  "is-change-request": _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_WORKBOOK_METADATA_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_WORKBOOK_METADATA_VIEW + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_WORKBOOK_METADATA_ACCESS,
          attrs: { title: "WORKBOOK ACCESS REQUEST", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-workbook", {
                ref: _vm.MODAL_WORKBOOK_METADATA_ACCESS + "_body",
                attrs: {
                  item: _vm.objDashboard,
                  "user-tableau": _vm.userTableau,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_WORKBOOK_METADATA_ACCESS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_WORKBOOK_METADATA_ACCESS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_PREVIEW_IMAGE,
          attrs: { title: _vm.currentView.name, width: 850 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("b-img", {
                attrs: { src: _vm.currentImage.base64, fluid: "" },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASET_METADATA_VIEW,
          attrs: {
            title: (_vm.isReadonly ? "View" : "Change") + " Metadata Dataset",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-dataset", {
                ref: _vm.MODAL_DATASET_METADATA_VIEW + "_body",
                attrs: {
                  item: _vm.objDataset,
                  dataset_id: _vm.objDataset.dataset_id,
                  "show-buttons": !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  "is-change-request": _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_DATASET_METADATA_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_DATASET_METADATA_VIEW + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_SELECT_USER_BI,
          attrs: {
            title:
              _vm.biType == "dataset"
                ? _vm.objDataset.path_name + "/" + _vm.objDataset.object_name
                : _vm.objReport.path_name + "/" + _vm.objReport.object_name,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-select-bi-user", {
                ref: _vm.MODAL_SELECT_USER_BI + "_body",
                attrs: {
                  "user-b-i-options": _vm.userBIOptions,
                  item:
                    _vm.biType == "dataset" ? _vm.objDataset : _vm.objReport,
                  "bi-type": _vm.biType,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_SELECT_USER_BI].onClose()
                  },
                  openMetaDataset: _vm.openMetaDataset,
                  openMetaReport: _vm.openMetaReport,
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_SELECT_USER_BI + "_body"].onSubmit(
                        $event
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("botones.boton_aceptar")) + " ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASET_METADATA_ACCESS,
          attrs: { title: "DATASET ACCESS REQUEST", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-dataset", {
                ref: _vm.MODAL_DATASET_METADATA_ACCESS + "_body",
                attrs: {
                  item: _vm.objDataset,
                  "user-b-i": _vm.userBI,
                  "email-b-i": _vm.emailBI,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_DATASET_METADATA_ACCESS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_DATASET_METADATA_ACCESS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_METADATA_VIEW,
          attrs: {
            title: (_vm.isReadonly ? "View" : "Change") + " Report Metadata",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-report", {
                ref: _vm.MODAL_REPORT_METADATA_VIEW + "_body",
                attrs: {
                  item: _vm.objReport,
                  report_id: _vm.objReport.report_id,
                  "show-buttons": !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  "is-change-request": _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_REPORT_METADATA_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_REPORT_METADATA_VIEW + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_METADATA_ACCESS,
          attrs: { title: _vm.$t("my_tasks.form_request_title"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-report", {
                ref: _vm.MODAL_REPORT_METADATA_ACCESS + "_body",
                attrs: {
                  item: _vm.objReport,
                  "user-b-i": _vm.userBI,
                  "email-b-i": _vm.emailBI,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_REPORT_METADATA_ACCESS].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_REPORT_METADATA_ACCESS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_METADATA_VIEW_GDS,
          attrs: {
            title: _vm.isChangeRequest ? "Change report metadata" : "Metadata",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-report-datastudio", {
                ref: _vm.MODAL_REPORT_METADATA_VIEW_GDS + "_body",
                attrs: {
                  item: _vm.objReportGds,
                  report_id: _vm.objReportGds.report_id,
                  "show-buttons": !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  "is-change-request": _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_REPORT_METADATA_VIEW_GDS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_REPORT_METADATA_VIEW_GDS + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_METADATA_ACCESS_GDS,
          attrs: { title: _vm.$t("my_tasks.form_request_title"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-report-gds", {
                ref: _vm.MODAL_REPORT_METADATA_ACCESS_GDS + "_body",
                attrs: {
                  item: _vm.objReportGds,
                  "user-b-i": _vm.userBI,
                  "email-b-i": _vm.emailBI,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_REPORT_METADATA_ACCESS_GDS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_REPORT_METADATA_ACCESS_GDS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASOURCE_METADATA_VIEW_GDS,
          attrs: {
            title: (_vm.isReadonly ? "View" : "Change") + " Metadata Dataset",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-datasource-datastudio", {
                ref: _vm.MODAL_DATASOURCE_METADATA_VIEW_GDS + "_body",
                attrs: {
                  item: _vm.objDatasourceGds,
                  dataset_id: _vm.objDatasourceGds.dataset_id,
                  "show-buttons": !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  "is-change-request": _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_DATASOURCE_METADATA_VIEW_GDS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_DATASOURCE_METADATA_VIEW_GDS + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASOURCE_METADATA_ACCESS_GDS,
          attrs: { title: _vm.$t("my_tasks.form_request_title"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-datasource-ds", {
                ref: _vm.MODAL_DATASOURCE_METADATA_ACCESS_GDS + "_body",
                attrs: {
                  item: _vm.objDatasourceGds,
                  "user-b-i": _vm.userBI,
                  "email-b-i": _vm.emailBI,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_DATASOURCE_METADATA_ACCESS_GDS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_DATASOURCE_METADATA_ACCESS_GDS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }